import { ADD_WIDGET, REMOVE_WIDGET, SET_DOCK_ENABLED, SET_WIDGET_HIDDEN, SET_WIDGETS_ORDER, SET_COUNTERS_ENABLED } from '../constants'

export function addWidget(widgetType){
  return{
    type: ADD_WIDGET,
    data: widgetType
  }
}

export function removeWidget(widgetType){
  return{
    type: REMOVE_WIDGET,
    data: widgetType
  }
}

export function setDockEnabled(enabled){
  try {
    localStorage.setItem('widgets_dock_enabled', enabled ? '1' : '0');
  } catch (e) {
    /* storage disabled — ignore */
  }
  return {
    type: SET_DOCK_ENABLED,
    data: enabled
  }
}

export function setWidgetHidden(key, hidden){
  return {
    type: SET_WIDGET_HIDDEN,
    key,
    hidden
  }
}

export function setWidgetsOrder(order){
  return {
    type: SET_WIDGETS_ORDER,
    data: order
  }
}

export function setCountersEnabled(enabled){
  return {
    type: SET_COUNTERS_ENABLED,
    data: enabled
  }
}
